// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__kHd4j","childrenContainer":"tooltip_childrenContainer__-aoKf","rtl":"tooltip_rtl__Rraon"};